// extracted by mini-css-extract-plugin
export default {"projektprognosWrappers":"ProjektprognosWrappers_projektprognosWrappers__ZvWzO","modalContentContainer":"ProjektprognosWrappers_modalContentContainer__eduHn"};